/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Filter_AllInputs */

const cs_documents_filter_all = /** @type {(inputs: Documents_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vše`)
};

const en_documents_filter_all = /** @type {(inputs: Documents_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Documents_Filter_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_filter_all = /** @type {((inputs?: Documents_Filter_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Filter_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_filter_all(inputs)
	return cs_documents_filter_all(inputs)
});